import { TFiltersData } from '../../../../../../models';

export const isFilterStateDefault = (state: TFiltersData) => {
  const { services, shops, specializations } = state;
  return !services && !shops.length && !specializations.length;
};
